import React, { useState, useEffect } from 'react';
import P, { InferProps } from 'prop-types';
import TextField from '@mui/material/TextField';

function TextInput({
  setChange,
  setValidation,
  field,
  isReadOnly,
  fullWidth = false,
}: InferProps<typeof TextInput.propTypes>) {
  const [value, setValue] = useState(field.value);
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    setValue(field.value);
  }, [field]);

  useEffect(() => {
    const validate = async (newValue: string | number) => {
      const yupSchema = field.validation;

      try {
        await yupSchema.validate(newValue);
        setErrorMessage('');
      } catch (error: any) {
        setErrorMessage(error.message);
      } finally {
        setValidation(field.key, newValue, field.validation);
      }
    };

    validate(value);
  }, [field, setValidation, value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    setChange(field.key, e.target.value, field.validation, field.isTeamDataValue);
  };

  return (
    <>
      <TextField
        type="date"
        InputLabelProps={{
          shrink: true,
        }}
        disabled={field.key === 'Not available' || !!isReadOnly}
        value={value}
        onChange={handleChange}
        id={field.id}
        label={field.title}
        helperText={errorMessage}
        error={!!errorMessage}
        variant="outlined"
        fullWidth={fullWidth || false}
      />
    </>
  );
}

TextInput.propTypes = {
  field: P.shape({
    title: P.string.isRequired,
    id: P.string.isRequired,
    type: P.string.isRequired,
    validation: P.any,
    key: P.string,
    value: P.oneOfType([P.string, P.number]).isRequired,
    isTeamDataValue: P.bool,
  }).isRequired,
  setChange: P.func.isRequired,
  setValidation: P.func.isRequired,
  isReadOnly: P.bool,
  fullWidth: P.bool,
};

export default React.memo(TextInput);
